import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { forkJoin } from 'rxjs';
import { AuthService } from '../../../core/services/auth.service';
import { map, switchMap, take } from 'rxjs/operators';
import { ApiHelper } from '../../../core/services/apiHelper';
import { environment } from '../../../environments/environment';
import { CometChatService } from '../../../core/services/cometChat/cometChat.service';
import { CometChatSuperAdminService } from '../../../core/services/cometChat/cometChatSuperAdmin.service';
import { isPlatformBrowser } from '@angular/common';
import { UserDAO } from '../../../core/services/dao/userDAO';

@Injectable()
export class MessagingResolve implements Resolve<any> {
  private isBrowser: boolean;

  constructor(
    private authService: AuthService,
    private apiHelper: ApiHelper,
    private cometChatService: CometChatService,
    private cometChatSuperAdminService: CometChatSuperAdminService,
    private userDAO: UserDAO,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const isAdmin = this.userDAO.currentUserIs('Admin');
    const sessionResolve$ = this.authService.checkSession();

    if (this.isBrowser) {
      const initializationCalls = [];
      if (isAdmin) {
        initializationCalls.push(this.cometChatSuperAdminService.login());
      } else {
        initializationCalls.push(this.cometChatService.login());
      }

      return sessionResolve$.pipe(
        switchMap((session) =>
          forkJoin(initializationCalls).pipe(
            map(() => ({ sessionResolve: session })),
          ),
        ),
        take(1),
      );
    } else {
      return sessionResolve$.pipe(
        map((sessionResolve) => ({ sessionResolve })),
        take(1),
      );
    }
  }
}
